import React from 'react';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { useAppSelector } from 'shared/redux/store';
import AuditionItem from '../AuditionItem/AuditionItem';
import { AuditionItemsContainer, Heading, ScrollCont } from '../Audtion.styles';
import LoadingCont from '../LoadingCont';
import { MainCont, NoData } from './SelfTapes.styles';

interface Props {
  data: IAuditionSchedulesAttributes[];
  pending: IAuditionSchedulesAttributes[];
  isLoading: boolean;
  isPendingLoading: boolean;
}

const SelfTapes: React.FC<Props> = ({ data, isLoading, isPendingLoading, pending }) => {
  const isBothHaveData = data.length > 0 && pending.length > 0;
  const { user: userState } = useAppSelector((state: any) => state);
  const country = userState?.user?.attributes?.other_phone_numbers?.filter((num) => num.type === 'primary');
  const userCountry = country && country.length > 0 ? country[0].country_code.toLowerCase() : 'au';

  return isLoading || isPendingLoading ? (
    <LoadingCont />
  ) : (
    // <MainCont>
    //   <div>
    //     {data.length ? (
    //       <React.Fragment>
    //         <Heading>Confirmed ST Request</Heading>
    //         <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 150px)' : 'calc(100vh - 220px)' }}>
    //           <AuditionItemsContainer>
    //             {data.map((a) => (
    //               <AuditionItem data={a} />
    //             ))}
    //           </AuditionItemsContainer>
    //         </ScrollCont>
    //       </React.Fragment>
    //     ) : (
    //       <React.Fragment />
    //     )}
    //     {pending.length ? (
    //       <React.Fragment>
    //         <Heading style={{ marginTop: 20 }}>Pending ST Request</Heading>
    //         <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 150px)' : 'calc(100vh - 220px)' }}>
    //           <AuditionItemsContainer>
    //             {pending.map((a) => (
    //               <AuditionItem data={a} />
    //             ))}
    //           </AuditionItemsContainer>
    //         </ScrollCont>
    //       </React.Fragment>
    //     ) : (
    //       <React.Fragment />
    //     )}
    //   </div>
    // </MainCont>
    <MainCont>
      {data.length || pending.length ? (
        <div>
          {data.length ? (
            <React.Fragment>
              <Heading>Confirmed ST Request</Heading>
              <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 150px)' : 'calc(100vh - 220px)' }}>
                <AuditionItemsContainer>
                  {data.map((a) => (
                    <AuditionItem country={userCountry} data={a} />
                  ))}
                </AuditionItemsContainer>
              </ScrollCont>
            </React.Fragment>
          ) : (
            <React.Fragment />
          )}
          {pending.length ? (
            <React.Fragment>
              <Heading style={{ marginTop: 20 }}>Pending ST Request</Heading>
              <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 150px)' : 'calc(100vh - 220px)' }}>
                <AuditionItemsContainer>
                  {pending.map((a) => (
                    <AuditionItem country={userCountry} data={a} />
                  ))}
                </AuditionItemsContainer>
              </ScrollCont>
            </React.Fragment>
          ) : (
            <React.Fragment />
          )}
        </div>
      ) : (
        <NoData>No Data Available</NoData>
      )}
    </MainCont>
  );
};

export default SelfTapes;
